import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { EventData } from '../../types';


interface EventScheduleSectionProps {
  eventData: EventData;
}

const EventScheduleSection = ({ eventData }: EventScheduleSectionProps) => {
  const calculateDuration = (start: Date, end: Date) => {
    const diff = end.getTime() - start.getTime();
    return Math.floor(diff / (1000 * 3600 * 24)) + 1;
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      <h2 className="text-xl font-semibold mb-6 flex items-center gap-2">
        <CalendarDaysIcon className="w-6 h-6 text-blue-600" />
        Event Schedule
      </h2>
      <div className="grid grid-cols-3 gap-4">
        {[eventData.startDate, eventData.endDate].map((date, idx) => (
          <div key={idx} className="p-4 bg-blue-50 rounded-lg text-center">
            <div className="text-sm text-blue-600 mb-1">{idx === 0 ? 'Starts' : 'Ends'}</div>
            <div className="text-2xl font-bold text-gray-900">{date.getDate()}</div>
            <div className="text-sm text-gray-600">
              {date.toLocaleString('default', { month: 'short' })}
            </div>
          </div>
        ))}
        <div className="p-4 bg-blue-50 rounded-lg text-center">
          <div className="text-sm text-blue-600 mb-1">Duration</div>
          <div className="text-2xl font-bold text-gray-900">
            {calculateDuration(eventData.startDate, eventData.endDate)}
          </div>
          <div className="text-sm text-gray-600">Days</div>
        </div>
      </div>
    </div>
  );
};
export default EventScheduleSection